import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import CarLoader from './components/CarLoader'

import 'intl'
import 'intl/locale-data/jsonp/en.js'
//import 'intl/locale-data/jsonp/es.js'
import 'intl/locale-data/jsonp/fr.js'
//import 'intl/locale-data/jsonp/de.js'

const App = React.lazy( () => import("./LoadableApp"))

ReactDOM.render(<Suspense fallback={<CarLoader/>}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Suspense>,
    document.getElementById('root')
);

serviceWorker.register();
